import usePrivateAxios from "@/common/api/usePrivateAxios";
import { unFormatCurrency, unFormatPercentage } from "@/common/utils/unFormatters";
import { FeeTemplateValidationSchema } from "@/features/feeTemplates/schemas/create.schema";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

interface UseCreateFeeTemplateProps {
  onSuccess: () => void,
  onError: (error: AxiosError) => void;
}

export const useCreateFeeTemplate = ({
  onSuccess,
  onError,
}: UseCreateFeeTemplateProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createFeeTemplate'],
    mutationFn: async (form: FeeTemplateValidationSchema) => {
      const payload = {
        ...form,
        conditional_minimum_consumption: form?.enableMinimumConsumption && unFormatCurrency(form?.conditional_minimum_consumption || '') > 0 ? unFormatCurrency(form?.conditional_minimum_consumption || '') : undefined,
        default_value: form.calculate_as?.value === 'percentage' ? unFormatPercentage(form?.default_value) : unFormatCurrency(form?.default_value),
        kind: form.kind?.value,
        applicable_entity: form.applicable_entity?.value,
        option_id: form.option_id?.value,
        calculate_as: form.calculate_as?.value,
        payment_modality: form.payment_modality?.value,
        fee_template_applicable_products_attributes:
          form.enableApplicableProducts
            ? form.fee_template_applicable_products_attributes?.map((applicable) => ({ applicable_type: applicable.type, applicable_id: applicable.value }))
            : [],
        fee_template_applicable_capture_methods_attributes:
          form.enableApplicableCaptureMethods
            ? form.fee_template_applicable_capture_methods_attributes?.map((applicable) => ({ capture_method_id: applicable.value }))
            : [],
        applicable_establishment_commercial_kinds: form.applicable_establishment_commercial_kinds?.value,
      };
      return privateAxios.post('/billing/fee_templates', {
        fee_template: payload
      });
    },
    onSuccess,
    onError,
  });
};
